// extracted by mini-css-extract-plugin
module.exports = {"circle":"LogoSkeleton_circle__28tgU"};